import React from "react";

function About({ type }) {
  if (type === "why") {
    return (
      <div className="container two-column">
        <div>
          <h2 className="section-title">Why “Beyond” Badminton?</h2>
          <p>
            Because we go further than just playing the sport. We build confidence, friendships,
            community spirit, and opportunities for people to grow—on and off the court.
          </p>
        </div>
        <div>
          <ul className="bullet-list">
            <li>Supportive, community‑focused culture</li>
            <li>Inclusive environment for all ages and abilities</li>
            <li>Volunteer‑run and not‑for‑profit</li>
          </ul>
        </div>
      </div>
    );
  }

  if (type === "priority") {
    return (
      <div className="container">
        <h2 className="section-title">BBI Priority Booking</h2>
        <p className="section-intro">
          Members receive priority access to reserve their spot for our Wednesday and Sunday sessions.
        </p>
        <div className="two-column">
          <div>
            <h3>How It Works</h3>
            <ul className="bullet-list">
              <li>Members vote in the WhatsApp poll up to 24 hours before the session.</li>
              <li>Voting plus payment confirms the booking.</li>
              <li>Members get an early booking window before casual players.</li>
            </ul>
          </div>
          <div>
            <p>
              With our 18‑player cap across 3 courts, any unreserved spots are filled by unreserved
              members or casuals on a first‑come basis. This system ensures our members—who support
              the club all year—always have the best chance to play.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container two-column">
      <div>
        <h2 className="section-title">About Us</h2>
        <p>
          Beyond Badminton Incorporated (BBI) is a not‑for‑profit community badminton club on the
          Central Coast, open to all ages and all skill levels.
        </p>
        <p>
          We’re more than just a club—we’re a community built on respect, inclusiveness, and a
          genuine love for the game. BBI is run entirely by volunteers who are passionate about
          community sport.
        </p>
        <p>Our team coordinates:</p>
        <ul className="bullet-list">
          <li>Weekly social sessions</li>
          <li>Junior development pathways</li>
          <li>Women and girls participation initiatives</li>
          <li>Clear, fair policies and communication</li>
          <li>A safe, respectful environment for all players</li>
        </ul>
      </div>
      <div>
        <h3>Our Values</h3>
        <ul className="bullet-list">
          <li><strong>Respect</strong> – for every player, parent, and volunteer</li>
          <li><strong>Inclusiveness</strong> – everyone is welcome</li>
          <li><strong>Safety</strong> – physical and emotional wellbeing come first</li>
          <li><strong>Integrity</strong> – transparent decisions and fair processes</li>
          <li><strong>Enjoyment</strong> – badminton should always be fun</li>
        </ul>

        <h3>Our Vision</h3>
        <p>
          To create the Central Coast’s most welcoming and vibrant badminton community, where
          everyone—from beginners to seasoned players—feels supported, valued, and excited to be
          on court.
        </p>

        <h3>Our Mission</h3>
        <ul className="bullet-list">
          <li>Grow participation by making badminton accessible and enjoyable for all</li>
          <li>Provide inclusive spaces where new and experienced players can mix comfortably</li>
          <li>Support development through structured junior programs and beginner pathways</li>
          <li>Build community through connection, teamwork, and shared enjoyment of the sport</li>
        </ul>
      </div>
    </div>
  );
}

export default About;
